import React from 'react';
import {Message, Modal} from "semantic-ui-react";

export default function ErrorModal(props) {
    return <Modal basic
                  open={props.open}
                  onClose={props.onClose}>
        <Modal.Content>
            <Message negative
                     icon="exclamation triangle"
                     header={props.header}
                     content={props.error}/>
        </Modal.Content>
    </Modal>
}





// WEBPACK FOOTER //
// ./src/components/common/ErrorModal.js